import type { Filter } from '@atlassian/jira-common-directory-v2/src/model/shareable-entities/index.tsx';
import type { Response as ResponseType } from '@atlassian/jira-dashboards-common/src/services/types.tsx';
import type { PageRequest } from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import get from '../../../rest/dashboards/get/index.tsx';
import type { Response as RestResponse } from '../../../rest/dashboards/get/types.tsx';
import { transformDashboards } from './transformers.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Response = ResponseType;

const getDashboards = async (request: PageRequest, filter: Filter): Promise<Response> => {
	const restResponse: RestResponse = await get(request, filter);
	return transformDashboards(restResponse.values, restResponse.total);
};

export default getDashboards;
